import { Category } from '../products-page/components/products-categories/models/Category.model';
import styles from './FirstLevelProductCard.module.scss';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import * as authService from '../../auth/services/auth.service';
import { EMPTY_GUID } from '../../shared/constants/images-resolution.constants';
import { getDimensionedImage, getProductImageUrl } from '../../shared/services/get-attachments.service';
import globalStyles from '../../global-styles.module.scss';

import noImage from '../../assets/img/Fixcenter-noimage.png';
import { useTranslation } from '../../i18n/useTranslation';
import { useBetween } from '../../shared/use-between/use-between';
import { ProductImageUseBetween } from './use-between/product-image-use-between';

interface Props {
    category: Category;
    isCenter?: boolean;
    hasMargin?: boolean;
    heightImg?: number;
    widthImg?: number;
}

export default function FirstLevelProductCard({
    category,
    isCenter,
    hasMargin,
    heightImg = 200,
    widthImg = 200,
}: Props) {
    const { t } = useTranslation('translation');
    const { setHoverProductImageUuid } = useBetween(ProductImageUseBetween);

    const checkIfIsLoggedIn = (): boolean => {
        const isLoggedIn: boolean = authService.checkLogInStatus();
        return isLoggedIn;
    };

    return (
        <div
            className={`${styles.container} ${isCenter ? globalStyles.flex_center_item : globalStyles.float_left_item} ${hasMargin ? globalStyles.mb_3 : globalStyles.mb_0}`}
        >
            <div style={{ height: `${heightImg}px`, width: `${widthImg}px` }} className={styles.product_image}>
                <Link
                    to={checkIfIsLoggedIn() ? `/webshop/category/${category.name}/${category.id}` : '/login'}
                    className={styles.image_container}
                >
                    {category && category.imageIds && category.imageIds[0] && category.imageIds[0] !== EMPTY_GUID ? (
                        <img
                            src={getProductImageUrl(category.imageIds[0])}
                            alt={t('Product') as string}
                            loading="lazy"
                            onMouseEnter={() => setHoverProductImageUuid(category.imageIds[0])}
                        />
                    ) : (
                        <img src={noImage} loading="lazy" alt={t('Product') as string} />
                    )}
                </Link>
            </div>
            <div className={styles.product_name}>
                <Link
                    to={checkIfIsLoggedIn() ? `/webshop/category/${category.name}/${category.id}` : '/login'}
                    className={styles.link}
                >
                    {category.translation ? category.translation : category.name}
                </Link>
            </div>
        </div>
    );
}
